import { render } from "./svg-icon.vue?vue&type=template&id=7b1cc7d9"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"

import "./svg-icon.vue?vue&type=style&index=0&id=7b1cc7d9&lang=css"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__